export default "__VITE_ASSET__Dqs7l3y9__"